//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectMemberModal from '@/views/coupons/components/select-member-modal';

export default {
    name: 'binding-weChat',
    components: { SelectMemberModal },
    props: {
        value: {
            type: Boolean, default: false
        }
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        addMember(data) {
            console.log(data);
        }
    },
    watch: {}
};
